export default __webpack_public_path__ + "static/media/welcomeGrid.ff51de39.png";